const Step1Data = {
  subtitle: {
    pl: "Wybierz kategorie problemów, które chcesz uwzględnić w wyliczeniach:",
    en: "Select the problem categories you want to include in your calculations:",
  },
  availableChallenges: {
    pl: [
      {
        id: "A",
        name: "Chcę zastąpić pracę kontrolerów oraz zwiększyć skuteczność kontroli",
        value: 0,
      },
      {
        id: "B",
        name: "Chcę monitorować proces produkcji i dzięki temu zredukować koszty braków",
        value: 0,
      },
      {
        id: "C",
        name: "Chcę uniknąć reklamacji od Klienta Końcowego",
        value: 0,
      },
      {
        id: "D",
        name: "Nie chcę niepotrzebnie przetwarzać braków",
        value: 0,
      },
      {
        id: "E",
        name: "Chcę zredukować koszty przestojów lub awarii spowodowanych błędem obsługi",
        value: 0,
      },
    ],
    en: [
      {
        id: "A",
        name: "I’d like to replace the work of controllers and increase the effectiveness of inspections",
        value: 0,
      },
      {
        id: "B",
        name: "I’d like to monitor the production process and thus reduce the costs of defects",
        value: 0,
      },
      {
        id: "C",
        name: "I’d like to avoid complaints from the end customer",
        value: 0,
      },
      {
        id: "D",
        name: "I don’t want to process faulty components unnecessarily",
        value: 0,
      },
      {
        id: "E",
        name: "I’d like to reduce the costs of downtime or failure caused by staff error",
        value: 0,
      },
    ],
  },
};
export default Step1Data;
